import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import actions from './actions';

export const initialState = {
  appNav: {
    collapse: false,
    isOpen: false
  },
  homeNav: {
    transparent: true
  }
};

const reducers = {
  [actions.appNav.setCollapse]: ({ appNav, ...state }, { payload: { collapse } }) => ({
    ...state,
    appNav: {
      ...appNav,
      collapse
    }
  }),
  [actions.homeNav.setTransparent]: ({ homeNav, ...state }, { payload: { transparent } }) => ({
    ...state,
    homeNav: {
      ...homeNav,
      transparent
    }
  }),
  [actions.appNav.toggleIsOpen]: ({ appNav: { isOpen, ...appNav }, ...state }, action) => ({
    ...state,
    appNav: {
      ...appNav,
      isOpen: !isOpen
    }
  }),
  [LOCATION_CHANGE]: (state, action) => initialState
};

export default handleActions(reducers, initialState);



// WEBPACK FOOTER //
// ./src/state/modules/navbar/reducers.js